import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "tpco_cookie_consent_v1";

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === null) {
      // afficher après 1.2s pour ne pas gêner le LCP
      const t = setTimeout(() => setOpen(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const set = (analytics) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ analytics, ts: Date.now() }));
    setOpen(false);
    // Trigger pour AnalyticsLoader
    window.dispatchEvent(new CustomEvent("tpco-consent-changed", { detail: { analytics } }));
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 lg:left-auto lg:right-6 lg:bottom-6 lg:max-w-md z-50 bg-white border border-[#E2E5F1] rounded-xl shadow-2xl p-5 lg:p-6"
          data-testid="cookie-consent"
        >
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#FCE4EC] text-[#E91E63] flex items-center justify-center shrink-0">
              <Cookie className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-display text-base font-bold text-[#0F1A3D] tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                Cookies & confidentialité
              </h3>
              <p className="text-xs text-[#4B5775] leading-relaxed mt-1.5">
                Nous utilisons des cookies pour améliorer votre expérience et mesurer l'audience du site. Vous pouvez tout accepter ou refuser à tout moment.
              </p>
              <div className="flex items-center gap-2 mt-4">
                <button
                  onClick={() => set(true)}
                  className="h-10 px-4 rounded-lg bg-[#E91E63] hover:bg-[#D81B60] text-white text-[11px] font-bold uppercase tracking-wider transition"
                  data-testid="cookie-accept"
                >
                  Tout accepter
                </button>
                <button
                  onClick={() => set(false)}
                  className="h-10 px-4 rounded-lg border border-[#E2E5F1] hover:border-[#1E3A8A] text-[#1E3A8A] text-[11px] font-bold uppercase tracking-wider transition"
                  data-testid="cookie-refuse"
                >
                  Refuser
                </button>
              </div>
            </div>
            <button
              onClick={() => set(false)}
              className="text-[#9CA3B5] hover:text-[#0F1A3D] transition"
              aria-label="Fermer"
              data-testid="cookie-close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
